import Reveal from "./Reveal";
import { useLanguage } from "../context/LanguageContext";

const SectionHeader = ({ eyebrow, heading, sub, light = false, align = "start" }) => {
  const { isRtl } = useLanguage();
  const eyebrowClass = isRtl
    ? "text-sm font-bold text-bronze-dark"
    : "text-xs font-semibold uppercase tracking-[0.3em] text-bronze-dark";
  const alignClass = align === "center" ? "items-center text-center" : "items-start text-start";

  return (
    <Reveal className={`flex flex-col gap-5 ${alignClass}`}>
      <span className={`flex items-center gap-3 ${eyebrowClass}`} data-testid="section-eyebrow">
        <span className="h-px w-10 bg-bronze" aria-hidden="true" />
        {eyebrow}
      </span>
      <h2
        className={`font-head text-4xl sm:text-5xl leading-[1.08] ${
          isRtl ? "" : "tracking-tight"
        } ${light ? "text-ivory" : "text-ink"}`}
      >
        {heading}
      </h2>
      {sub && (
        <p className={`max-w-2xl text-base md:text-lg ${light ? "text-ivory/75" : "text-taupe"}`}>
          {sub}
        </p>
      )}
    </Reveal>
  );
};

export default SectionHeader;
